import React from 'react'
import { connect } from 'react-redux'
import c from 'classnames'
import Carousel, { Modal, ModalGateway } from 'react-images'
import pluralize from 'pluralize'

import Button from 'discada/dist/Button'
import Icon from 'discada/dist/Icon'

import ScrollButtons from 'components/widgets/ScrollButtons'
import { getEntity } from 'selectors/entitySelectors'
import { getImages } from 'selectors/inventorySelectors'
import { getWritePermission } from 'selectors/authSelectors'
import { toggleQueryValue } from 'actions/pageStateActions'
import { getQueryValue } from 'selectors/pageStateSelectors'
import { isPaymentIQView } from 'selectors/appStatusSelectors'

import './Gallery.scss'

class Gallery extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = { currentImage: 0 }

    this.closeLightbox = () =>
      this.setState({
        currentImage: 0,
        lightboxIsOpen: false,
      })

    this.openLightbox = idx =>
      this.setState({
        currentImage: idx,
        lightboxIsOpen: true,
      })
  }

  render() {
    let {
        images,
        isManager,
        shouldShowCustomerView,
        paymentIqView,
      } = this.props,
      size = isManager ? 'small' : 'regular',
      { lightboxIsOpen } = this.state

    return (
      <div
        id="vrp-gallery"
        className={c(
          'vrp-gallery',
          'vrp-section',
          `vrp-gallery-images-${images.length}`,
          {
            'vrp-gallery-few': images.length < 5,
            'vrp-gallery-manager': !shouldShowCustomerView || paymentIqView,
            'vrp-gallery-paymentiq': paymentIqView,
          },
        )}
      >
        <div className={c('vrp-gallery-inner')}>
          {(images || []).map((image, i) => (
            <div
              key={i}
              style={{ background: `url(${image.src})` }}
              onClick={() => this.openLightbox(i)}
            />
          ))}
        </div>
        {(isManager || images.length > 1) && (
          <ScrollButtons
            size={size}
            container="#vrp-gallery .vrp-gallery-inner"
          >
            <p className="control">
              {paymentIqView && (
                <a
                  href={window.location.href}
                  className={`button frikin-button has-icon is-${size}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon icon="external-link-alt" />
                  IQ
                </a>
              )}
              <Button size={size} icon="camera">
                {pluralize('Photos', images.length, true)}
              </Button>
            </p>
          </ScrollButtons>
        )}

        <ModalGateway>
          {lightboxIsOpen ? (
            <Modal onClose={this.closeLightbox}>
              <Carousel views={images} />
            </Modal>
          ) : null}
        </ModalGateway>
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  let id = op.id || op.vehicleId,
    vehicle = getEntity(state, id)

  return {
    ...op,
    id,
    vehicle,
    images: getImages(state, id),
    isManager: getWritePermission(state, 'deal.fields/profit'),
    isCustomerView: !!getQueryValue(state, 'customerView', false),
    paymentIqView: isPaymentIQView(),
  }
}

export default connect(
  mapStateToProps,
  { toggleQueryValue },
)(Gallery)
